import React from 'react';
import '../Loader/Loader.css';

/**
 * AgGridLoadingOverlay
 * Renders the application's signature loader animation inside the AG Grid
 * viewport on a clean white background with pulse animation.
 */
const AgGridLoadingOverlay = () => {
    return (
        <div
            className="w-full h-full min-h-[220px] flex flex-col items-center justify-center m-auto text-center pointer-events-none select-none animate-pulse"
            role="status"
            aria-live="polite"
            aria-label="Loading table data"
        >
            <div className="lds-ellipsis lds-ellipsis-primary mx-auto">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default AgGridLoadingOverlay;
